import type { FaireProductEntity } from "../../entity_types/product";

export const starter_collection_47: FaireProductEntity = {
  token: "starter_collection_47",
  type: "product",
  name: "Beachwood \u2014 Organic Certified",
  brandName: "Canyon Coffee",
  imageUrl: "",
  priceDollars: 22,
  msrpDollars: 44,
  description: "Migrated starter collections product",
  tags: ["starter-collections"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "playground-data-migration",
  },
};
